import { TextField } from '@mui/material';
import styled, { css } from 'styled-components';

import { TStyledTextFieldProps } from '@/shared/components/ui/form/components/text-field/text-field.types';

export const StyledTextField = styled(TextField)<TStyledTextFieldProps>`
  && {
    label {
      transition: color 200ms ease-in-out;
      ${({ theme }) => theme.typography.button2};
      transform: unset;
      position: unset;
      margin-bottom: 0.75rem;
      color: ${({ theme }) => theme.palette.text.primary};
      user-select: text;

      ${({ theme, $optional }) =>
        Boolean($optional) &&
        css`
          &::after {
            content: '${$optional}';
            color: ${theme.palette.text.secondary};
            margin-left: 0.375rem;
          }
        `};

      .MuiFormLabel-asterisk {
        display: none;
      }

      &.Mui-focused {
        color: ${({ theme }) => theme.palette.primary.main};
      }

      &.Mui-error {
        color: ${({ theme }) => theme.palette.status.red.text};
      }
    }

    .MuiInputBase-root {
      border-radius: ${({ theme, $size }) =>
        theme.shape.inputRadius[$size || 'medium']};
      ${({ theme }) => theme.typography.p8};

      &:not(.MuiInputBase-multiline) {
        height: ${({ theme, $size }) =>
          theme.shape.inputHeight[$size || 'medium']};
      }
    }

    .MuiOutlinedInput-root {
      transition: all 0.2s ease-in-out;
      background: ${({ theme }) => theme.palette.background.input};

      input {
        // Fixed block padding outgrew the root's height at size="small".
        padding: 0 0.75rem;
        height: 100%;
        box-sizing: border-box;
        &::placeholder {
          opacity: 1;
          color: ${({ theme }) => theme.palette.text.secondary};
        }
      }

      fieldset {
        border: none;
        box-shadow: inset 0 0 0 1px
          ${({ theme }) => theme.palette.stroke.primary};
      }

      &:hover {
        fieldset {
          box-shadow: inset 0 0 0 1px
            ${({ theme }) => theme.palette.stroke.secondary};
        }
      }

      &.Mui-focused {
        fieldset {
          box-shadow: inset 0 0 0 1px
            ${({ theme }) => theme.palette.primary.main};
        }
      }

      &.Mui-error {
        background: ${({ theme }) => theme.palette.danger.light};

        fieldset {
          box-shadow: inset 0 0 0 1px
            ${({ theme }) => theme.palette.status.red.stroke};
        }
      }

      &.Mui-disabled {
        background: ${({ theme }) => theme.palette.background.default};

        fieldset {
          box-shadow: inset 0 0 0 1px
            ${({ theme }) => theme.palette.stroke.primary};
        }

        button {
          svg {
            color: ${({ theme }) => theme.palette.text.disabled};
          }
        }
      }
    }

    .MuiFormHelperText-root {
      margin-top: 0.5rem;
      margin-left: 0;
      ${({ theme }) => theme.typography.p8};

      &.Mui-error {
        color: ${({ theme }) => theme.palette.status.red.text};
      }
    }
  }
`;
